import { 
  GET_CONVERSION_LOG_STICKY_COLUMNS, 
  GET_CONVERSION_LOG_STICKY_COLUMNS_ERROR,
  GET_CONVERSION_LOG_STICKY_COLUMNS_SUCCESS, 
  UPDATE_CONVERSION_LOG_STICKY_COLUMNS, 
  UPDATE_CONVERSION_LOG_STICKY_COLUMNS_ERROR, 
  UPDATE_CONVERSION_LOG_STICKY_COLUMNS_SUCCESS 
} from "./actionTypes"

const initialState = {
  error: null,
  user_column_preference_conversion_log: null,
  loading: false
}

const UserConversionLogColumnPreference = (state = initialState, action) => {
  switch (action.type) {
    case GET_CONVERSION_LOG_STICKY_COLUMNS:
      return {
        ...state,
        loading: true
      }

    case GET_CONVERSION_LOG_STICKY_COLUMNS_SUCCESS:
      return {
        ...state,
        user_column_preference_conversion_log: action.payload,
        loading: false
      }

    case GET_CONVERSION_LOG_STICKY_COLUMNS_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }

    case UPDATE_CONVERSION_LOG_STICKY_COLUMNS:
      return {
        ...state,
        loading: true
      }

    case UPDATE_CONVERSION_LOG_STICKY_COLUMNS_SUCCESS:
      return {
        ...state,
        user_column_preference_conversion_log: action.payload,
        loading: false
      }

    case UPDATE_CONVERSION_LOG_STICKY_COLUMNS_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }
    default:
      return state
  }
}

export default UserConversionLogColumnPreference;
